import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const EMOTIONS = {
  happy: { label: 'Heureuse', img: '/emotions/happy.png' },
  neutral: { label: 'Neutre', img: '/emotions/neutral.png' },
  fear: { label: 'Peur', img: '/emotions/fear.png' },
  anger: { label: 'Colère', img: '/emotions/anger.png' },
  sadness: { label: 'Tristesse', img: '/emotions/sadness.png' },
  stressed: { label: 'Stressée', img: '/emotions/stressed.png' },
};

const MESSAGES = {
  happy: "Ce mois-ci ton cœur a surtout été joyeux — continue de semer ces graines de lumière 🌸",
  neutral: "Ce mois-ci ton cœur est resté paisible et posé — une belle stabilité 🌸",
  fear: "Ce mois-ci ton cœur a traversé des peurs — sois douce avec toi-même 🌸",
  anger: "Ce mois-ci ton cœur a traversé de la colère — le souffle l'apaisera 🌸",
  sadness: "Ce mois-ci ton cœur a porté de la tristesse — chaque graine repousse, avec patience 🌸",
  stressed: "Ce mois-ci ton cœur a été sous tension — offre-lui des pauses respiration 🌸",
};

export const MonthlyMoodRecap = () => {
  const [recap, setRecap] = useState(null);

  useEffect(() => {
    const now = new Date();
    const month = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
    const force = localStorage.getItem('mood_recap_force') === '1';
    if (!force && now.getDate() < lastDay - 1) return;
    if (!force && localStorage.getItem(`mood_recap_shown_${month}`)) return;
    const deviceId = localStorage.getItem('mood_device_id');
    if (!deviceId) return;
    fetch(`${API_URL}/api/moods/recap?device_id=${deviceId}&month=${month}`)
      .then((r) => r.json())
      .then((d) => {
        if (d.total > 0) {
          setRecap(d);
          localStorage.setItem(`mood_recap_shown_${month}`, '1');
        }
      })
      .catch(() => {});
  }, []);

  if (!recap) return null;

  const dominant = Object.entries(recap.counts).sort((a, b) => b[1] - a[1])[0][0];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-5" data-testid="monthly-recap-modal">
      <div className="absolute inset-0 bg-black/30" onClick={() => setRecap(null)} />
      <div className="relative bg-[#FAF9F6] rounded-3xl p-6 w-full max-w-sm shadow-xl border border-gray-200 text-center">
        <button
          onClick={() => setRecap(null)}
          data-testid="monthly-recap-close"
          className="absolute top-3 right-3 p-1.5 rounded-full text-gray-400 hover:text-gray-600"
        >
          <X size={18} />
        </button>

        <h2 className="text-lg text-gray-800 mb-1" style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 600 }}>
          Ton mois en émotions
        </h2>
        <img src={EMOTIONS[dominant].img} alt={EMOTIONS[dominant].label} className="w-20 h-20 object-contain mx-auto my-3" />
        <p className="text-sm text-gray-600 mb-5" data-testid="monthly-recap-message">
          {MESSAGES[dominant]}
        </p>

        <div className="space-y-2.5 text-left">
          {Object.keys(EMOTIONS).filter((id) => recap.counts[id]).map((id) => (
            <div key={id} className="flex items-center gap-3">
              <img src={EMOTIONS[id].img} alt={EMOTIONS[id].label} className="w-8 h-8 object-contain" />
              <span className="text-xs text-gray-700 w-16">{EMOTIONS[id].label}</span>
              <div className="flex-1 h-2 rounded-full bg-gray-200 overflow-hidden">
                <div className="h-full rounded-full bg-[#F79AAE]" style={{ width: `${(recap.counts[id] / recap.total) * 100}%` }} />
              </div>
              <span className="text-xs text-gray-500">{recap.counts[id]}j</span>
            </div>
          ))}
        </div>

        <button
          onClick={() => setRecap(null)}
          data-testid="monthly-recap-ok"
          className="mt-6 w-full py-2.5 rounded-full text-sm text-white bg-[#F79AAE] active:scale-[0.98] transition-transform"
        >
          Merci 🌸
        </button>
      </div>
    </div>
  );
};
